document.addEventListener("DOMContentLoaded", () => {
  const swipers = document.querySelectorAll('.lcs-swiper');
  
  swipers.forEach(container => {
    const paginationEl = container.querySelector('.swiper-pagination');
    
    const isAutoplay = container.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(container.dataset.speed, 10) * 1000;
    const isLoop = container.dataset.loop === 'true';
    const transitionSpeed = parseInt(container.dataset.transition, 10);
    
    let swiperParams = {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: isLoop,
      speed: isNaN(transitionSpeed) ? 300 : transitionSpeed,
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      on: {
        slideChangeTransitionEnd: function () {
          if (isAutoplay) {
            const activeBullet = container.querySelector('.swiper-pagination-bullet-active');
            if (activeBullet) {
              activeBullet.style.animation = 'none';
              activeBullet.offsetHeight;
              activeBullet.style.animation = null;
            }
          }
        }
      }
    };

    if (isAutoplay && !isNaN(autoplaySpeed) && autoplaySpeed > 0) {
      swiperParams.autoplay = {
        delay: autoplaySpeed,
        disableOnInteraction: false
      };
    }
    
    new Swiper(container, swiperParams);
  });
});